import { render, staticRenderFns } from "./offline_aftersale_detail.vue?vue&type=template&id=9e3870d2&scoped=true"
import script from "./offline_aftersale_detail.vue?vue&type=script&lang=js"
export * from "./offline_aftersale_detail.vue?vue&type=script&lang=js"
import style0 from "./offline_aftersale_detail.vue?vue&type=style&index=0&id=9e3870d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3870d2",
  null
  
)

export default component.exports